/**
 * @generated SignedSource<<8158e509906dd65c7663d14d60c5c5a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConditionalFormattingSidebarExperience_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RuleList_view">;
  readonly " $fragmentType": "ConditionalFormattingSidebarExperience_view";
};
export type ConditionalFormattingSidebarExperience_view$key = {
  readonly " $data"?: ConditionalFormattingSidebarExperience_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperience_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConditionalFormattingSidebarExperience_view",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "kind": "FragmentSpread",
      "name": "RuleList_view"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "e83efaac5cf4fadc776e4ada9c645e0b";

export default node;
